import buildShipToPartyInfo from './buildShipToPartyInfo';

const buildModifyOrderPayload = ({
  orderId,
  shipment = null,
  shipments = [],
  shipToPartyOperation = null,
  products = [],
}) => {
  // Handle single shipment (backward compatibility)
  if (shipment && !shipments.length) {
    return {
      order_id: orderId,
      order_products: [],
      order_products_delivery: [
        {
          ship_to_party_info: buildShipToPartyInfo(
            shipment,
            shipToPartyOperation
          ),
          products_info: products,
        },
      ],
    };
  }
  
  // Handle multiple shipments (new batch functionality)
  if (shipments.length > 0) {
    return {
      order_id: orderId,
      order_products: [],
      order_products_delivery: shipments.map(({ shipment, products, operation }) => ({
        ship_to_party_info: buildShipToPartyInfo(
          shipment,
          operation || shipToPartyOperation
        ),
        products_info: products || [],
      })),
    };
  }

  // Fallback for empty case
  return {
    order_id: orderId,
    order_products: [],
    order_products_delivery: [],
  };
};

export default buildModifyOrderPayload;
